export const FEATURE_FLAGS = {
  aiTicketsEnabled: 'ai_tickets.enabled',
  agentV4AiChat: 'agent_v4.ai_chat',
  /**
   * Shadow only: after each live Agent V4 guest reply, Jev scores the guest's message, records
   * whether it needs a reply and whether GPT-6 Luna could answer it, and dry-runs Luna when it
   * could. The live reply never changes.
   */
  agentV4GuestModelRouterShadow: 'agent_v4.guest_model_router_shadow',
  agentV4ResponseFlow: 'agent_v4.responseflow',
  agentV4ResponseFlowShadow: 'agent_v4.responseflow_shadow',
  agentV4Slack: 'agent_v4.slack',
  agentV4SemanticApi: 'agent_v4.semantic_api',
  inboxClientSwitch: 'inbox.client_switch',
  labsV4Workspace: 'labs_v4.workspace',
  learningEscalationReplies: 'learning.escalation_replies',
  /** Team chat: `/chat` (channels and DMs), its rail entry, ⌘K section and every API. */
  teamChatEnabled: 'team_chat.enabled',
  /** Team chat: mentioned workspace agents reply in channels and threads. */
  teamChatAgent: 'team_chat.agent',
} as const

export type FeatureFlagName = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS]
